import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { normalizeLanguageCode } from './config'
import ruTranslations from './locales/ru.json'
import enTranslations from './locales/en.json'
import ukTranslations from './locales/uk.json'
import ptTranslations from './locales/pt.json'
import esTranslations from './locales/es.json'
import trTranslations from './locales/tr.json'
import kkTranslations from './locales/kk.json'
import uzTranslations from './locales/uz.json'
import idTranslations from './locales/id.json'
import tgTranslations from './locales/tg.json'
import kyTranslations from './locales/ky.json'
import arTranslations from './locales/ar.json'
import faTranslations from './locales/fa.json'
import ruTeamTranslations from '../features/team/i18n/ru.json'
import enTeamTranslations from '../features/team/i18n/en.json'
import ukTeamTranslations from '../features/team/i18n/uk.json'
import ptTeamTranslations from '../features/team/i18n/pt.json'
import esTeamTranslations from '../features/team/i18n/es.json'
import trTeamTranslations from '../features/team/i18n/tr.json'
import kkTeamTranslations from '../features/team/i18n/kk.json'
import uzTeamTranslations from '../features/team/i18n/uz.json'
import idTeamTranslations from '../features/team/i18n/id.json'
import tgTeamTranslations from '../features/team/i18n/tg.json'
import kyTeamTranslations from '../features/team/i18n/ky.json'
import arTeamTranslations from '../features/team/i18n/ar.json'
import faTeamTranslations from '../features/team/i18n/fa.json'
import ruProfileTranslations from '../features/profile/i18n/ru.json'
import enProfileTranslations from '../features/profile/i18n/en.json'
import ukProfileTranslations from '../features/profile/i18n/uk.json'
import ptProfileTranslations from '../features/profile/i18n/pt.json'
import esProfileTranslations from '../features/profile/i18n/es.json'
import trProfileTranslations from '../features/profile/i18n/tr.json'
import kkProfileTranslations from '../features/profile/i18n/kk.json'
import uzProfileTranslations from '../features/profile/i18n/uz.json'
import idProfileTranslations from '../features/profile/i18n/id.json'
import tgProfileTranslations from '../features/profile/i18n/tg.json'
import kyProfileTranslations from '../features/profile/i18n/ky.json'
import arProfileTranslations from '../features/profile/i18n/ar.json'
import faProfileTranslations from '../features/profile/i18n/fa.json'
import ruUpgraderTranslations from '../features/upgrader/i18n/ru.json'
import enUpgraderTranslations from '../features/upgrader/i18n/en.json'
import ukUpgraderTranslations from '../features/upgrader/i18n/uk.json'
import ptUpgraderTranslations from '../features/upgrader/i18n/pt.json'
import esUpgraderTranslations from '../features/upgrader/i18n/es.json'
import trUpgraderTranslations from '../features/upgrader/i18n/tr.json'
import kkUpgraderTranslations from '../features/upgrader/i18n/kk.json'
import uzUpgraderTranslations from '../features/upgrader/i18n/uz.json'
import idUpgraderTranslations from '../features/upgrader/i18n/id.json'
import tgUpgraderTranslations from '../features/upgrader/i18n/tg.json'
import kyUpgraderTranslations from '../features/upgrader/i18n/ky.json'
import arUpgraderTranslations from '../features/upgrader/i18n/ar.json'
import faUpgraderTranslations from '../features/upgrader/i18n/fa.json'
import ruContractNewTranslations from '../features/contract/i18n/ru.json'
import enContractNewTranslations from '../features/contract/i18n/en.json'
import ukContractNewTranslations from '../features/contract/i18n/uk.json'
import ptContractNewTranslations from '../features/contract/i18n/pt.json'
import esContractNewTranslations from '../features/contract/i18n/es.json'
import trContractNewTranslations from '../features/contract/i18n/tr.json'
import kkContractNewTranslations from '../features/contract/i18n/kk.json'
import uzContractNewTranslations from '../features/contract/i18n/uz.json'
import idContractNewTranslations from '../features/contract/i18n/id.json'
import tgContractNewTranslations from '../features/contract/i18n/tg.json'
import kyContractNewTranslations from '../features/contract/i18n/ky.json'
import arContractNewTranslations from '../features/contract/i18n/ar.json'
import faContractNewTranslations from '../features/contract/i18n/fa.json'
import { tjsResources } from '../features/withdraw/i18n/tjs'
import { minesResources } from '../features/mines/i18n'
import { slotResources } from '../features/slot/i18n'
import { eventResources } from '../features/event/i18n'
import { withdrawResources } from '../features/withdraw/i18n'

const getTelegramLanguage = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return normalizeLanguageCode(window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code)
}

const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') {
    return null
  }

  const browserLanguages = Array.isArray(navigator.languages) && navigator.languages.length > 0
    ? navigator.languages
    : [navigator.language]

  for (const browserLanguage of browserLanguages) {
    const normalizedLanguage = normalizeLanguageCode(browserLanguage)

    if (normalizedLanguage) {
      return normalizedLanguage
    }
  }

  return null
}

const getInitialLanguage = () => {
  return getTelegramLanguage() || getBrowserLanguage() || 'ru'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        translation: { ...ruTranslations, ...ruTeamTranslations, ...ruProfileTranslations, ...ruUpgraderTranslations, ...ruContractNewTranslations }
      },
      en: {
        translation: { ...enTranslations, ...enTeamTranslations, ...enProfileTranslations, ...enUpgraderTranslations, ...enContractNewTranslations }
      },
      uk: {
        translation: { ...ukTranslations, ...ukTeamTranslations, ...ukProfileTranslations, ...ukUpgraderTranslations, ...ukContractNewTranslations }
      },
      pt: {
        translation: { ...ptTranslations, ...ptTeamTranslations, ...ptProfileTranslations, ...ptUpgraderTranslations, ...ptContractNewTranslations }
      },
      es: {
        translation: { ...esTranslations, ...esTeamTranslations, ...esProfileTranslations, ...esUpgraderTranslations, ...esContractNewTranslations }
      },
      tr: {
        translation: { ...trTranslations, ...trTeamTranslations, ...trProfileTranslations, ...trUpgraderTranslations, ...trContractNewTranslations }
      },
      kk: {
        translation: { ...kkTranslations, ...kkTeamTranslations, ...kkProfileTranslations, ...kkUpgraderTranslations, ...kkContractNewTranslations }
      },
      uz: {
        translation: { ...uzTranslations, ...uzTeamTranslations, ...uzProfileTranslations, ...uzUpgraderTranslations, ...uzContractNewTranslations }
      },
      id: {
        translation: { ...idTranslations, ...idTeamTranslations, ...idProfileTranslations, ...idUpgraderTranslations, ...idContractNewTranslations }
      },
      tg: { translation: { ...tgTranslations, ...tgTeamTranslations, ...tgProfileTranslations, ...tgUpgraderTranslations, ...tgContractNewTranslations } },
      ky: { translation: { ...kyTranslations, ...kyTeamTranslations, ...kyProfileTranslations, ...kyUpgraderTranslations, ...kyContractNewTranslations } },
      ar: { translation: { ...arTranslations, ...arTeamTranslations, ...arProfileTranslations, ...arUpgraderTranslations, ...arContractNewTranslations } },
      fa: { translation: { ...faTranslations, ...faTeamTranslations, ...faProfileTranslations, ...faUpgraderTranslations, ...faContractNewTranslations } }
    },
    lng: getInitialLanguage(),
    fallbackLng: ['en', 'ru'],
    interpolation: {
      escapeValue: false
    }
  })

Object.entries(tjsResources).forEach(([language, resource]) => {
  i18n.addResourceBundle(language, 'translation', resource, true, true)
})
Object.entries(minesResources).forEach(([language, resource]) => {
  i18n.addResourceBundle(language, 'translation', resource, true, true)
})
Object.entries(slotResources).forEach(([language, resource]) => {
  i18n.addResourceBundle(language, 'translation', resource, true, true)
})
Object.entries(eventResources).forEach(([language, resource]) => {
  i18n.addResourceBundle(language, 'translation', resource, true, true)
})
Object.entries(withdrawResources).forEach(([language, resource]) => {
  i18n.addResourceBundle(language, 'translation', resource, true, true)
})

export default i18n
